import React from "react";
import {getFlagArray} from "../utils";
import {useTranslation} from "react-i18next";

interface EnumViewerProps {
    type: any;
    value: number;
    isFlag?: boolean;
    className?: string;
}

export const EnumViewer = React.memo(({type, value, isFlag=false, className}: EnumViewerProps) => {
    const [t] = useTranslation();

    const getKey = (v: number) => {
        return Object.keys(type).find(k => type[k] === v);
    }

    const getEnumText = () => {

        let enumText = "";
        if(isFlag) {
            if(value === 0) {
                let none = getKey(0);
                enumText = none ? t(none) : "0";
            } else {
                let values = getFlagArray(value);

                enumText = values.map(v => {
                    let key = getKey(v);
                    if(key) {
                        return t(`enum.${key}`);
                    } else{
                        return v;
                    }
                }).join('، ');
            }
        } else {
            let key = getKey(value);

            if(key) {
                enumText = t(`enum.${key}`);
            } else {
                enumText = value.toString();
            }
        }

        return enumText;
    }

    return (
    <span className={className}>{ getEnumText() }</span>
    )
});
